import React from 'react'

import {bool, combine} from '../styles/classname-utils'
import classes from './pricing-toggle.module.scss'

interface IPricingToggle {
  showAnnualPricing: boolean,
  setShowAnnualPricing: () => void
}

const PricingToggle: React.FC<IPricingToggle> = ({
  showAnnualPricing, setShowAnnualPricing,
}) => (
  <div className={classes.pricingToggleBlock}>
    <label className={classes.pricingToggleContainer} htmlFor='pricingToggle'>
      <input
        type='checkbox'
        className={classes.pricingToggleInput}
        onClick={setShowAnnualPricing}
        id='pricingToggle'
        checked={showAnnualPricing}
      />
      <div className={classes.pricingToggle} />
      <div className={combine(classes.options, bool(!showAnnualPricing, classes.optionSelected))}>
        Pay Monthly
      </div>
      <div className={combine(classes.options, bool(showAnnualPricing, classes.optionSelected))}>
        Pay Annually
      </div>
    </label>
    <div className={classes.savePercentText}>Save up to <b>25%</b> paying upfront</div>
  </div>
)

export default PricingToggle
